// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowOutCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-out-circle': IconArrowOutCircle;
    }
}

/**
 * The icon component for the 'arrowOutCircle' icon
 */
export class IconArrowOutCircle extends Icon {
    public constructor() {
        super(arrowOutCircle16X16);
    }
}

registerIcon('icon-arrow-out-circle', IconArrowOutCircle);
export const iconArrowOutCircleTag = 'nimble-icon-arrow-out-circle';
